module.exports = __webpack_public_path__ + "src/img/artist/artistpage6.svg?ec54477e563f1305c9b4c0fedfaadbbc";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage6.svg
// module id = 124
// module chunks = 0